import {HEADING_KEYS} from '@udecode/plate-heading';
import {BoldPlugin, ItalicPlugin, UnderlinePlugin, StrikethroughPlugin, CodePlugin} from '@udecode/plate-basic-marks/react';
import {HighlightPlugin} from '@udecode/plate-highlight/react';
import {BlockquotePlugin} from '@udecode/plate-block-quote/react';
import {BulletedListPlugin, ListItemPlugin, NumberedListPlugin} from '@udecode/plate-list/react';
import {LinkPlugin} from '@udecode/plate-link/react';
import {HorizontalRulePlugin} from '@udecode/plate-horizontal-rule/react';
import {ParagraphPlugin} from '@udecode/plate/react';
import {ImagePlugin, PlaceholderPlugin} from '@udecode/plate-media/react';
import {ColumnItemPlugin, ColumnPlugin} from "@udecode/plate-layout/react";
import {IframePlugin} from "./plugins/IframePlugin";
import {DivPlugin} from "./plugins/DivPlugin";

export const NodeType = {
    PARAGRAPH: ParagraphPlugin.key,
    ORDERED_LIST: NumberedListPlugin.key,
    UNORDERED_LIST: BulletedListPlugin.key,
    LIST_ITEM: ListItemPlugin.key,
    THEMATIC_BREAK: HorizontalRulePlugin.key,
    BLOCK_QUOTE: BlockquotePlugin.key,
    HEADING_ONE: HEADING_KEYS.h1,
    HEADING_TWO: HEADING_KEYS.h2,
    HEADING_THREE: HEADING_KEYS.h3,
    HEADING_FOUR: HEADING_KEYS.h4,
    HEADING_FIVE: HEADING_KEYS.h5,
    HEADING_SIX: HEADING_KEYS.h6,
    LINK: LinkPlugin.key,
    IMAGE: ImagePlugin.key,
    MEDIA_PLACEHOLDER: PlaceholderPlugin.key,
    COLUMN_ITEM: ColumnItemPlugin.key,
    COLUMN_GROUP: ColumnPlugin.key,
    IFRAME: IframePlugin.key,
    DIV: DivPlugin.key,
}

export const MarkType = {
    EMPHASIS: ItalicPlugin.key,
    STRONG: BoldPlugin.key,
    UNDERLINE: UnderlinePlugin.key,
    STRIKETHROUGH: StrikethroughPlugin.key,
    CODE: CodePlugin.key,
    HIGHLIGHT: HighlightPlugin.key,
}

export const markdownDefaultMaxLength = 200000;
export const defaultValue = [
    {
        type: NodeType.PARAGRAPH,
        children: [{text: ""}],
    },
];

export const STRUCTURAL_TYPES: string[] = [
    ColumnPlugin.key,
    ColumnItemPlugin.key,
    DivPlugin.key,
];